import React from 'react';

import { Nullable } from '@clearverify/types';

import { InboxListItemInfoFragment, useInboxItemsScrollableListQuery } from 'src/api';
import { RESOURCES_INBOX_ITEM_ID } from 'src/constants/resources';
import { InboxItemExtended } from 'src/types/inbox';

import { useResourcesInboxItem } from '../resources/useResourcesInboxItem';

export const useInboxItemScrollableById = (id: Nullable<string>) => {
  const isResourcesInboxItem = id === RESOURCES_INBOX_ITEM_ID;

  const { data, loading } = useInboxItemsScrollableListQuery({
    variables: {
      where: {
        id: { equals: id },
      },
    },
    skip: !id || isResourcesInboxItem,
  });

  const {
    hasResourcesInboxItem,
    resourcesInboxItem,
    loading: resourcesInboxItemLoading,
  } = useResourcesInboxItem(!isResourcesInboxItem);

  const inboxItem = React.useMemo(() => {
    if (!data?.getInboxItemsList[0]) return null;
    return data.getInboxItemsList[0] as InboxItemExtended<InboxListItemInfoFragment>;
  }, [data?.getInboxItemsList]);

  if (isResourcesInboxItem && hasResourcesInboxItem) {
    return {
      inboxItem: resourcesInboxItem as InboxItemExtended<InboxListItemInfoFragment>,
      loading: resourcesInboxItemLoading,
    };
  }

  return {
    inboxItem,
    loading,
  };
};
